import React from "react";
import {
  formatInvoiceDateTime,
  formatMoneyCents,
  formatPaymentMethodLabel,
  formatServicePeriod,
  lineDescription,
} from "./invoiceFormatters";

const PrintableComponent = React.forwardRef(({ invoice, isPrinting }, ref) => {
  const subtotal = formatMoneyCents(
    Math.max(0, Number(invoice?.amount_paid || 0) - Number(invoice?.tax_amount || 0))
  );
  const tax = formatMoneyCents(
    Number(invoice?.amount_paid || 0) > 0 ? invoice?.tax_amount : 0
  );
  const total = formatMoneyCents(invoice?.amount_paid);
  const paymentLabel = formatPaymentMethodLabel(invoice);
  const description = lineDescription(invoice);
  const servicePeriod = formatServicePeriod(
    invoice?.subs_current_period_start,
    invoice?.subs_current_period_end
  );
  const paymentDate = formatInvoiceDateTime(invoice?.payment_time);

  return (
    <div
      id="printable_component"
      className={`invoice-printable-root ${isPrinting ? "invoice-printable-root--printing" : ""}`}
      ref={ref}
    >
      <article
        className={`invoice-document ${isPrinting ? "" : "invoice-document--screen"}`}
      >
        <header className="invoice-document__header">
          <img
            src="/assets/image/blue-logo.png"
            className="invoice-document__logo"
            alt="WOW Backup and Restore"
          />
          <div className="invoice-document__issuer">
            <p className="invoice-document__issuer-name">WOWzer Technologies Inc.</p>
            <p>
              45 – 15898 27 Avenue
              <br />
              Surrey, BC V3Z 0T2, Canada
            </p>
            <p className="invoice-document__issuer-tax">
              Tax Number: 78616 9003 RT0001
            </p>
          </div>
        </header>

        <div className="invoice-document__meta-grid">
          <section className="invoice-document__panel invoice-document__panel--muted">
            <h2 className="invoice-document__panel-title">Billed to</h2>
            <dl className="invoice-document__dl">
              <div>
                <dt>Company</dt>
                <dd>{invoice?.company_name || "—"}</dd>
              </div>
              <div>
                <dt>Contact</dt>
                <dd>{invoice?.contact_name || "—"}</dd>
              </div>
              <div>
                <dt>Address</dt>
                <dd>{invoice?.company_address || "—"}</dd>
              </div>
              <div>
                <dt>Tax #</dt>
                <dd>{invoice?.company_tax_number || "—"}</dd>
              </div>
            </dl>
          </section>

          <section className="invoice-document__panel invoice-document__panel--accent">
            <h2 className="invoice-document__panel-title">Invoice details</h2>
            <dl className="invoice-document__dl">
              <div>
                <dt>Invoice no.</dt>
                <dd className="invoice-document__mono">{invoice?.reference_id || "—"}</dd>
              </div>
              {invoice?.org_name ? (
                <div>
                  <dt>Organization</dt>
                  <dd className="invoice-document__org-name">{invoice.org_name}</dd>
                </div>
              ) : null}
              <div>
                <dt>Payment date</dt>
                <dd>{paymentDate}</dd>
              </div>
              <div>
                <dt>Payment method</dt>
                <dd>{paymentLabel}</dd>
              </div>
            </dl>
          </section>
        </div>

        <div className="invoice-document__table-wrap">
          <table className="invoice-document__table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Service period</th>
                <th className="invoice-document__num">Amount</th>
                <th className="invoice-document__num">Tax</th>
                <th className="invoice-document__num">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{paymentDate}</td>
                <td>{description}</td>
                <td>{servicePeriod}</td>
                <td className="invoice-document__num">${subtotal}</td>
                <td className="invoice-document__num">${tax}</td>
                <td className="invoice-document__num">${total}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <footer className="invoice-document__footer">
          <div className="invoice-document__totals">
            <div className="invoice-document__totals-row">
              <span>Subtotal</span>
              <span>${subtotal}</span>
            </div>
            <div className="invoice-document__totals-row">
              <span>Tax</span>
              <span>${tax}</span>
            </div>
            <div className="invoice-document__totals-row invoice-document__totals-row--grand">
              <span>Total</span>
              <span>${total}</span>
            </div>
          </div>
          <p className="invoice-document__footnote">
            Reference: {invoice?.reference_id || "—"}
          </p>
        </footer>
      </article>
    </div>
  );
});

PrintableComponent.displayName = "PrintableComponent";

export default PrintableComponent;
